import { BehaviorSubject } from "rxjs";
import * as i0 from "@angular/core";
import * as i1 from "@progress/kendo-angular-l10n";
export var RtlEnum;
(function (RtlEnum) {
    RtlEnum[RtlEnum["rtl"] = 0] = "rtl";
    RtlEnum[RtlEnum["ltr"] = 1] = "ltr";
})(RtlEnum || (RtlEnum = {}));
var RtlService = /** @class */ (function () {
    function RtlService(messages) {
        this.messages = messages;
        this.rtlMode = false;
        this.loginRtlModeSubject = new BehaviorSubject(null);
    }
    /**
     * Checks if application is in rtl mode
     */
    RtlService.prototype.isRtl = function () {
        return this.rtlMode;
    };
    /**
     * Returns loginRtlModeSubject observable
     */
    RtlService.prototype.getLoginRtlModeObservable = function () {
        return this.loginRtlModeSubject.asObservable();
    };
    /**
     * Sets application direction
     * @param lang
     * @param loginInProgress
     */
    RtlService.prototype.setDir = function (lang, loginInProgress) {
        if (!loginInProgress) {
            this.setLoginDir(lang.rightToLeft);
        }
        this.rtlMode = lang.rightToLeft;
        document.dir = RtlEnum[this.rtlMode ? 0 : 1];
        this.messages.notify(this.rtlMode);
    };
    RtlService.prototype.setLoginDir = function (isRtl) {
        this.loginRtlModeSubject.next(isRtl);
    };
    RtlService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RtlService_Factory() { return new RtlService(i0.ɵɵinject(i1.MessageService)); }, token: RtlService, providedIn: "root" });
    return RtlService;
}());
export { RtlService };
